<template>
  <div class="card">
    <div class="card-body" style="height: 100vh;">
      <h5 class="card-title text-center font-weight-bold">To Do List</h5>
      <div class="" v-if="loading">
        <div class="loader"></div>
      </div>
      <div v-else>
        <div class="d-flex justify-content-between">
          <a  href="" data-toggle="modal" data-target="#newTodoModal" class="" @click="fixModal('newTodoModal')"> Add </a>
          <a  href="" v-if='todoList' data-toggle="modal" data-target="#todo-list" class="" @click="fixModal('todo-list')"> View All</a>
        </div>
      <perfect-scrollbar class="scroll-area" v-if="todoList && todoList.length !==0">
        <div class="container">
          <ul class="list-group list-group-flush">
            <li  class="list-group-item todo-item" v-for="value in todoList" :key="value.id">
              <div class="d-flex">
                <div class="pr-10"><input type="checkbox" class="mt-5" aria-label="Checkbox for following text input"   v-model="value.status" @click="updateTodoStatus(value)" ></div>
                <div>{{notesAdjustment(value.notes)}}</div>
              </div>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
        <p v-else class="card-text text-center text-danger mb-3 font-weight-bold">No data found.</p>
      </div>
    </div>

    <div class="new-todo-modal position-relative">
      <div class="modal fade newTodoModal" id="newTodoModal" tabindex="-1" role="dialog" aria-labelledby="newTodoModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <form @submit.prevent="AddTodo">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add new Todo</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                  <label>Notes</label>
                  <textarea v-model="newTodo.notes" class="form-control" rows="4"></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary" :disabled="newTodoProcessing ||  !newTodo.notes">
                  <div class="loader small_loader" v-if="newTodoProcessing"></div>
                  <span v-else>Submit</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="todo-list position-relative">
      <div class="modal fade todo-list" id="todo-list" tabindex="-1" role="dialog" aria-labelledby="todo-list" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <form @submit.prevent="AddTodo">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">To Do List</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="" v-if="loading">
                  <!-- Show the loader when async operation is going on -->
                  <div class="loader"></div>
                </div>
                <perfect-scrollbar class="scroll-area-modal" v-else >
                <table  class="table table-striped single-outage-table">
                  <thead>
                  <tr class="text-center">
                    <th></th>
                    <th width="30%" class="text-center"><b>Is Checked</b></th>
                    <th class="text-left"><b>Notes</b></th>
                    <th class="text-center"><b>Actions</b></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) in todoList" :key="index.id">
                    <td></td>
                    <td width="30%" class="text-center"><input type="checkbox" aria-label="Checkbox for following text input"   v-model="row.status" @click="updateTodoStatus(row, false)" ></td>
                    <td class="text-left">{{row.notes}}</td>
                    <td class="text-center">
                      <button type="button" rel="tooltip" class="btn btn-danger btn-icon btn-sm  btn-neutral  " @click="removeTodo(row, false)">
                        <i class="fa fa-times"></i>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
                </perfect-scrollbar >
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
import swal from 'sweetalert2';
import {db} from "@/firebase/init";

export default {
  name: "Todo",
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      loading: true,
      todoList: [],
      newTodo:{
        notes: '',
        status: false,
        userUid: null,
        createdAt : new Date,
      },
      newTodoProcessing: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
  },
  methods:{
    async removeTodo(todo, hasLimit= true){
      this.loading= true;
      try{
        await db.collection('todos').doc(todo.id).delete();
      }
      catch(e){
        console.log('Could not change todo status');
        console.log(e)
      }
      finally {
        await this.getAllUserTodos(hasLimit)
      }
    },
    async updateTodoStatus(todo, hasLimit= true){
    todo.status = !todo.status;
    this.loading= true;
    try{
      await db.collection('todos').doc(todo.id).update({...todo});
    }
    catch(e){
     console.log('Could not change todo status');
     console.log(e)
    }
    finally {
      await this.getAllUserTodos(hasLimit)
    }
    },
    notesAdjustment(value){
      return value && value.length > 100 ? `${value.slice(0,100)}...` : value
    },
    async AddTodo(){
      this.newTodoProcessing= true;
      this.newTodo.userUid=this.user.uid;
      this.newTodo.createdAt=  new Date().toISOString();
      try {
        await db.collection('todos').add({...this.newTodo});}

      catch(e){
        console.log(e)
        console.log("Couldn't insert todo")
      }
      finally {
        this.newTodoProcessing= false;
        this.loading= true;
        this.newTodo={
          notes: '',
          userUid: null,
        }
       await  swal({
          title: "Success",
          text: "Todo was added",
          type: "success",
        });
        // eslint-disable-next-line no-undef
        $('#newTodoModal').modal('hide');
        await this.getAllUserTodos()
      }
    },
    async getAllUserTodos(hasLimit=true){
      try{
        this.todoList= []
        const query = hasLimit ? db.collection('todos').where('userUid', '==' , this.user.uid).orderBy('createdAt', 'desc').limit(20)
            :db.collection('todos').where('userUid', '==' , this.user.uid).orderBy('createdAt', 'desc')
          const ref = await query.get();
        console.log(ref)
        if(ref.empty){
          this.loading = false;
          return;
        }
        ref.docs.forEach((value)=>{
          this.todoList.push({id : value.id, ...value.data()} )
        })
        // this.todoList.sort(function(a,b){
        //   return new Date(b.createdAt) - new Date(a.createdAt);
        // });

        this.loading = false;
      }
      catch(e){
        console.log(e);
        console.log('Error in fetching user todos');
      }
      console.log('Todo List', this.todoList)
    },
    fixModal(value) {
      if(value==='newTodoModal'){
        this.newTodo.notes= '';
      }
      if(value==='todo-list'){
        this.getAllUserTodos(false)
      }
      /* eslint-disable */
      $(`.${value}`).removeClass("modal-backdrop");
    },
  },
  mounted() {
    this.getAllUserTodos()
  }
}
</script>
<style >
.list-group-item{
  &.todo-item{
   padding: 14px 0px;
  }
}
.scroll-area {
  position: relative;
  max-height: calc(100vh - 150px);
  /*overflow: hidden;*/
}
.scroll-area-modal {
  position: relative;
  max-height: calc(100vh - 150px);
  overflow: hidden;
}
</style>
